import Button from 'src/components/base/Button/Button';
import {
  deleteAllTypeEvent,
  deleteAppointment,
} from 'src/redux/services/calenderServices';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { EventType } from '../../../constants/EventEnums';
import './DeleteEventModal.scss';
import { Typography } from "src/latest/src/components";

interface Props {
  isRecurrent: boolean;
  eventId: string;
  getLatestSchedules: any;
  eventType?: string;
}

const DeleteEventModal: React.FC<Props> = ({
  isRecurrent,
  eventId,
  getLatestSchedules,
  eventType,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isDisable, setIsDisable] = useState(true);

  const dispatch = useDispatch();

  const handleDeleteClick = async () => {
    setIsProcessing(true);

    try {
      if (eventType === EventType.Appointment) {
        await deleteAppointment(eventId);
      } else {
        await deleteAllTypeEvent(eventId, isRecurrent, selectedOption);
      }

      await getLatestSchedules();
      dispatch(clearModalContent());
    } catch (error) {
      console.error('Error deleting event:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCancelClick = () => {
    dispatch(clearModalContent());
  };

  useEffect(() => {
    if (
      selectedOption === 'Deletesingleevent' ||
      selectedOption === 'Deletefutureevent' ||
      selectedOption === 'Deletethewholeseries'
    ) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [selectedOption]);

  return (
    <>
      <div className="delete-model">
        {isRecurrent && (
          <div>
            <div className="delete-recurring">
              <div className="mt-5">
                <Typography variant="size-18">
                  {' '}
                  This event is part of series.
                </Typography>
              </div>
              <div className="form-check mt-5">
                <input
                  className="form-check-input"
                  type="radio"
                  name="eventOptions"
                  id="option1"
                  value="Deletesingleevent"
                  checked={selectedOption === 'Deletesingleevent'}
                  onChange={e => setSelectedOption(e.target.value)}
                />
                <label className="form-check-label" htmlFor="option1">
                  <Typography
                    variant="size-16"
                    className={`fw-semibold ${selectedOption === 'Deletesingleevent' ? '' : 'color-grey'
                      }`}
                  >
                    {' '}
                    Delete this single event
                  </Typography>
                </label>
              </div>
              <div className="form-check mt-4">
                <input
                  className="form-check-input"
                  type="radio"
                  name="eventOptions"
                  id="option2"
                  value="Deletefutureevent"
                  checked={selectedOption === 'Deletefutureevent'}
                  onChange={e => setSelectedOption(e.target.value)}
                />
                <label className="form-check-label" htmlFor="option2">
                  <Typography
                    variant="size-16"
                    className={`fw-semibold ${selectedOption === 'Deletefutureevent' ? '' : 'color-grey'
                      }`}
                  >
                    {' '}
                    Delete this and future events
                  </Typography>
                </label>
              </div>
              <div className="form-check mt-4">
                <input
                  className="form-check-input"
                  type="radio"
                  name="eventOptions"
                  id="option3"
                  value="Deletethewholeseries"
                  checked={selectedOption === 'Deletethewholeseries'}
                  onChange={e => setSelectedOption(e.target.value)}
                />
                <label className="form-check-label" htmlFor="option3">
                  <Typography
                    variant="size-16"
                    className={`fw-semibold ${selectedOption === 'Deletethewholeseries'
                      ? ''
                      : 'color-grey'
                      }`}
                  >
                    {' '}
                    Delete the whole series
                  </Typography>
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="mt-5">
          <Button
            onClick={handleDeleteClick}
            label="Delete"
            className="Delete-button"
            isProcessing={isProcessing}
            disabled={isDisable && isRecurrent}
          />
          <Button
            className="ms-5 cancel-button"
            variant="light"
            label="Cancel"
            onClick={handleCancelClick}
          />
        </div>
      </div>
    </>
  );
};

export default DeleteEventModal;
